<template>
    <div class="mt-4">
        <h5 class="status-label">Connection Information</h5>
        <template v-if="model.credentials.user_data.first_name">
          <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
              <span class="mt-2"><b>User Name:</b> {{ model.credentials.user_data.first_name }} {{
                  model.credentials.user_data.last_name
                }}</span>
            </el-col>
          </el-row>
        </template>
        <template v-if="model.credentials.user_id">
          <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
              <span class="mt-2"><b>User ID:</b> {{ model.credentials.user_id }}</span>
            </el-col>
          </el-row>
        </template>
        <template v-if="model.credentials.location_id">
          <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
              <span class="mt-2"><b>Location ID:</b> {{ model.credentials.location_id }}</span>
            </el-col>
          </el-row>
        </template>
        <template v-if="model.credentials.company_id">
          <el-row :gutter="20" class="mt-2">
            <el-col :span="24">
              <span class="mt-2"><b>Company ID:</b> {{ model.credentials.company_id }}</span>
            </el-col>
          </el-row>
        </template>
        <template v-if="model.credentials.scopes">
            <el-row :gutter="20" class="mt-2">
                <el-col :span="24">
                    <span><b>Scopes:</b></span>
                </el-col>
                <el-col :span="24" class="mt-2">
                    <code>{{ model.credentials.scopes }}</code>
                </el-col>
            </el-row>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        model: {
            type: Object,
            required: true
        },
    }
}
</script>
